import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { Observable } from 'rxjs';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { map, startWith, take } from 'rxjs/operators';
import { SelectedArea } from 'src/app/shared/area-select.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-camisa-trieur-card-I',
    templateUrl: './camisa-trieur-card-I.component.html'
})

export class CamisaTrieurCardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;


    public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSafra?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLoteDS?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listHibridoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public dados: any[] = [];
    
    @Output() mkCalc = new EventEmitter();



    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected route: ActivatedRoute, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Dados do Híbrido', false);
        if (this.areaSelect === SelectedArea.Comercial) {
            this.formulario = this.formBuilder.group({
                site_recebimento: [null, [Validators.required]],
                data_estrategia: [null, [Validators.required]],
                hibrido_rnc_linhagem: [null, [Validators.required]],
                safra: [null, [Validators.required]],
                lote_ds: [null, [Validators.required]],
                volume_analisado: [null, [Validators.required]]
            });

        }

    }


    public async ngOnInit(): Promise<void> {
        Promise.all([
            this.getLists(),
            this.setSite()
        ])
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public setSite() {
        this.formulario?.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListSafra(),
            this.getListHibridoRNC(),
            this.createFilterSafra(),
            this.createFilterHibrido()]);
    }

    async getListHibridoRNC(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'hibrido_rnc')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listHibrido = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listHibridoOriginal = this.listHibrido;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }

    async getListSafra(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'safra')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listSafra = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listSafraOriginal = this.listSafra;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    async createFilterHibrido(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listHibridoOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listHibrido = this.listHibridoOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listHibrido = this.listHibridoOriginal;
            }
        } else {
            this.listHibrido = this.listHibridoOriginal;
        }
    }

    async createFilterSafra(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listSafra = this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listSafra = this.listSafraOriginal;
            }
        } else {
            this.listSafra = this.listSafraOriginal;
        }
    }


    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    getListLoteDS($event) {
        if (this.formulario?.get('safra').value && this.formulario?.get('hibrido_rnc_linhagem').value) {
            this.formularioService.getListLoteDSForCamisaTrieur(this.formulario?.get('safra').value, this.formulario?.get('hibrido_rnc_linhagem').value)
                .pipe(take(1))
                .toPromise()
                .then((response) => {
                    if (!!response?.data) {
                        this.listLoteDS = this.generalService.orderByDropDownList(
                            response.data as DropDownListDTO[]
                        );
                    }
                })
                .catch(async (error: HttpErrorResponse) => {
                    this.notificationService.showNotificationError(
                        error,
                        '',
                        TypeMessage.ListErrorHibrido
                    );
                });
        }
    }


    async onChangeLotDS($event) {
       
        console.log("init");
        if (this.formulario?.get('lote_ds').value) {
            this.formularioService.getDadosFromLoteDS(this.formulario?.get('safra').value, this.formulario?.get('lote_ds').value, this.formulario?.get('site_recebimento').value).pipe(take(1))
            .toPromise()
            .then((response) => {
                if (response.data){
                    this.mkCalc.emit(response.data);
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
        }
    }

}

